import { Divider } from "@material-ui/core"

const VNDivider = (props) => {
  return <Divider aria-hidden={true} {...props} />
}

export default VNDivider

